__turbopack_context__.v({
  "cta": "dnGssq_cta",
  "logo": "dnGssq_logo",
  "shimmer": "dnGssq_shimmer",
  "strip": "dnGssq_strip",
  "strip--static": "dnGssq_strip--static",
  "text": "dnGssq_text",
  "text-bar-sweep": "dnGssq_text-bar-sweep",
  "tone": "dnGssq_tone",
  "tone--error": "dnGssq_tone--error",
  "tone--info": "dnGssq_tone--info",
  "tone--success": "dnGssq_tone--success",
  "tone--warning": "dnGssq_tone--warning",
});
